module.exports = __webpack_public_path__ + "media/stylesheets/images/cancel-57b4159ce8e730d0587b5502a5c2c546.png";